// 编码
export const encodeString = (str: string): string => {
  return btoa(unescape(encodeURIComponent(str)));
};

// 解码
export const decodeString = (str: string): string => {
  return decodeURIComponent(escape(atob(str)));
};

export const isEncoded = (str: string): boolean => {
  // 尝试解码并重新编码，如果结果与原字符串相同，说明是通过 encodeString 编码的
  try {
    if (!str || typeof str !== "string") {
      return false;
    }
    if (str.length % 4 !== 0) {
      return false;
    }
    return (
      /^[A-Za-z0-9+/=]+$/.test(str) &&
      !/[^A-Za-z0-9+/=]/.test(str) &&
      atob(str).length > 0
    ); // 能解码就算
  } catch {
    return false;
  }
};
